var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ab-image"},[_c('img',{staticClass:"ab-image__img",attrs:{"alt":_vm.alt,"src":_vm.src,"loading":_vm.lazy ? 'lazy' : null}})])
}
var staticRenderFns = []

export { render, staticRenderFns }